// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckBoxIcon_checkbox__Xtq6t"};